import React from 'react';
import { Form, Input } from 'antd';
import { checkNumber, conditionCheckNumber } from 'util/validators';
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: true,
  };

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = (key, inputValue = '') => {
    const { record, handleSave, handleError } = this.props;
    const value = inputValue || this.form.getFieldValue(key);

    if (key === 'value') {
      if (!conditionCheckNumber(value)) {
        handleError(record.id);
        return;
      }
    }

    handleError(null);
    handleSave({ ...record, [key]: value });
  };

  renderCell = form => {
    this.form = form;
    const { children, dataIndex, record, title, updating } = this.props;
    const { editing } = this.state;
    const indexField = `${dataIndex}_${record.id}`;

    const formItem = <Form.Item style={{ margin: 0 }}>
      {form.getFieldDecorator(indexField, {
        initialValue: record[dataIndex],
        rules: [{ validator: checkNumber }],
      })(<Input disabled={updating} placeholder={title} onChange={e => this.save(dataIndex, e.target.value)} ref={node => (this.input = node)} />)}
    </Form.Item>

    return editing ? (
      formItem
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.toggleEdit}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      handleError,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

export {
  EditableFormRow,
  EditableCell,
}